var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9749 15.9384L6.70575 10.6693L8.23458 9.15966L10.9 11.825V3.70001H13.0499V11.825L15.7153 9.15966L17.2441 10.6693L11.9749 15.9384ZM6.15765 20.3C5.47377 20.3 4.89318 20.0613 4.4159 19.584C3.9386 19.1067 3.69995 18.5261 3.69995 17.8423V15.1308H5.84993V17.8423C5.84993 17.9192 5.88198 17.9897 5.94608 18.0538C6.01019 18.1179 6.08072 18.15 6.15765 18.15H17.8422C17.9191 18.15 17.9897 18.1179 18.0538 18.0538C18.1179 17.9897 18.1499 17.9192 18.1499 17.8423V15.1308H20.2999V17.8423C20.2999 18.5307 20.0613 19.1125 19.584 19.5875C19.1067 20.0625 18.5261 20.3 17.8422 20.3H6.15765Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.29a79ab6a597ee24698c8f5b8b89e02e.svg";
export { ForwardRef as ReactComponent };